/**
 * Gets a link to the hardware details page depending on miner model name
 * @param {string} modelName miner model name to generate a slug. Example: "Antminer s19j"
 * @returns {string} a link to the hardware details page with
 * a slug depending on miner model name. Example "/hardware/antminer-s19j"
 */
export function getHardwareLink(modelName: string) {
  return `/hardware/${modelName.replace(/ /g, '-')}`
}
